/**
 * @fileoverview Helper functions around validating things with JSON schema
 *
 * Ajv wants you to compile validation functions, and it's kind of expensive, so we do that here
 * and cache the results for later.
 */

import Ajv, { JTDDataType, ValidateFunction } from 'ajv/dist/jtd';

const validator = new Ajv({
  unicodeRegExp: false, // this enables 'pattern' RegExp
  code: { es5: true },  // uses es5 specific code branches within Ajv
});

const validatorCache = new Map<JTDDataType<any>, ValidateFunction<any>>();

export function getValidator(schema: any): ValidateFunction<any> {
  if (validatorCache.has(schema)) {
    return validatorCache[schema];
  }

  let f = validator.compile(schema);
  validatorCache[schema] = f;
  return f;
}

export function validate<T = unknown>(schema: JTDDataType<T>, data: any): Promise<T> {
  let validate = getValidator(schema);
  if (validate(data)) {
    return Promise.resolve(data);
  }
  else {
    // I'm undecided whether I want this logging here.
    console.warn(`validation failed: ${validate.errors}`);
    return Promise.reject(validate.errors);
  }
}
